import {createAction, createReducer} from '@reduxjs/toolkit';

type OneStepType = {
    isEditingOneStepMethod: boolean;
};

export const initialState: OneStepType = {
    isEditingOneStepMethod: false,
};

export const setIsEditingOneStepMethod = createAction<boolean>(
    'CHECKOUT@SET_IS_EDITING_ONE_STEP_METHOD',
);

/**
 * oneStep reducer
 *
 * @return {OneStepType} - one step state
 */
export const oneStep = createReducer<OneStepType>(initialState, builder =>
    builder.addCase(setIsEditingOneStepMethod, (state, action) => ({
        ...state,
        isEditingOneStepMethod: action.payload,
    })),
);
